/** Read the current ShopLight `return` parameter or the backend legacy `redirect` alias. */
export function authReturnParam(search: string): string | null {
  const params = new URLSearchParams(search);
  return params.get('return') ?? params.get('redirect');
}
